/* tslint:disable */
/* This file should be ignored by git and the .svg file checked in instead.
 * This file was generated with 'svg-gen'. Manual changes will be lost. */
import React from 'react';
import { createIcon } from '../../createIcon';
export var FavoriteLockedIcon = createIcon("FavoriteLockedIcon", function (title) {
  var _color = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '#171717';
  return /*#__PURE__*/React.createElement("svg", {
    "data-replace-color": _color,
    width: "16",
    height: "16",
    viewBox: "0 0 16 16",
    fill: "none"
  }, /*#__PURE__*/React.createElement("title", null, title), /*#__PURE__*/React.createElement("path", {
    d: "m14.707 6.82.174-.172a.504.504 0 00-.312-.859l-4.025-.398L8.456 1.25a.512.512 0 00-.912 0l-2.09 4.14-4.026.4a.503.503 0 00-.312.858l3.312 3.283-1.222 4.462a.508.508 0 00.719.584l2.336-1.157",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.625 10.188h5.625v4.687H8.625v-4.688Z",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.438 7.375A1.875 1.875 0 009.562 9.25v.938h3.75V9.25a1.875 1.875 0 00-1.874-1.875Zm0 4.94a.234.234 0 00-.046.464.233.233 0 00.28-.23.234.234 0 00-.235-.234",
    stroke: _color,
    strokeWidth: "1.5",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }));
}, {
  "replaceColor": true
});